import React from "react";
import withTranslation, {
	Translation,
} from "src/components/hoc/withTranslation";
import { ApiUserMinimal } from "src/api/types";
import Avatar from "src/components/Avatar";
import Table from "src/components/Table";
import useTeams from "src/hooks/api/services/users/useTeams";
import moment from "moment";
import Button from "src/components/Button";
import Badge from "src/components/Badge";
import Link from "src/components/Link";
import CompanyUserStatus from "src/components/CompanyUserStatus";

interface UserListItemProps extends Translation {
	user: ApiUserMinimal;
}

const UserListItem = ({ t, user }: UserListItemProps) => {
	const { teams } = useTeams();
	const linked = teams.filter((item) => user.teams.includes(item.slug));

	return (
		<Table.Row>
			<Table.Cell>
				{user.status && <CompanyUserStatus status={user.status} />}
			</Table.Cell>
			<Table.Cell className="w-full">
				<Avatar.User {...{ user }} />
			</Table.Cell>
			<Table.Cell>
				<Link
					to={{ modal: `/profile/users/${user.hid}/edit` }}
					className="flex flex-wrap gap-2 w-80"
				>
					{linked.map((team) => (
						<Badge
							key={`team-${user.hid}-${team.slug}`}
							custom={team.color}
						>
							{team.name}
						</Badge>
					))}
				</Link>
			</Table.Cell>
			<Table.Cell>
				<span className="whitespace-nowrap">
					{moment(user.created_at).format("DD-MM-YYYY")}
				</span>
			</Table.Cell>
			<Table.Cell>
				<div className="flex gap-2">
					<Button
						to={{
							modal: `/profile/users/${user.hid}/edit?type=delete`,
						}}
						type="gray"
						iconOnly
						icon="fas fa-trash"
					></Button>
					<Button
						to={{ modal: `/profile/users/${user.hid}/edit` }}
						type="dark"
						iconOnly
						icon="fas fa-pencil"
					></Button>
				</div>
			</Table.Cell>
		</Table.Row>
	);
};

UserListItem.locale = {
	nl: {},
	en: {},
};

export default withTranslation(UserListItem);
